'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HS_logo_white = require('../../assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _eventbrite_logo = require('../../assets/eventbrite_logo.png');

var _eventbrite_logo2 = _interopRequireDefault(_eventbrite_logo);

var _eventbrite_integration = require('../../assets/eventbrite_integration.svg');

var _eventbrite_integration2 = _interopRequireDefault(_eventbrite_integration);

var _send_icon = require('../../assets/send_icon.svg');

var _send_icon2 = _interopRequireDefault(_send_icon);

var _customize_logo = require('../../assets/customize_logo.svg');

var _customize_logo2 = _interopRequireDefault(_customize_logo);

var _dashboard_icon = require('../../assets/dashboard_icon.svg');

var _dashboard_icon2 = _interopRequireDefault(_dashboard_icon);

var _overlay_left = require('../../assets/overlay_left.svg');

var _overlay_left2 = _interopRequireDefault(_overlay_left);

var _overlay_right = require('../../assets/overlay_right.svg');

var _overlay_right2 = _interopRequireDefault(_overlay_right);

var _socialSection = require('../../components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _faqSection = require('../../components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function EventbriteLandingPage(p) {
    var twitterLink = 'https://twitter.com/intent/tweet?text=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20%40HelloSign%20%2B%20%40Eventbrite&url=https%3A%2F%2Fwww.hellosign.com%2Feventbrite%3Futm_source%3Dtwitter%26utm_medium%3Ds2s';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=https%3A//www.hellosign.com/eventbrite?utm_source=facebook%26utm_medium=s2s';
    var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=https%3A//www.hellosign.com/eventbrite?utm_source=linkedin%26utm_medium=s2s&title=Check%20out%20the%20HelloSign%20Extension%20for%20Eventbrite&summary=It%27s%20easy%20to%20get%20attendee%20waivers%20%26%20forms%20signed%20with%20HelloSign%20%2B%20Eventbrite.%20https%3A//www.hellosign.com/eventbrite';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations' },
        _react2['default'].createElement(IllustrationArea, p),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(PricingPlansCTA, { position: 'top' }),
            _react2['default'].createElement(Benefits, null),
            _react2['default'].createElement(HowItWorks, null),
            _react2['default'].createElement(_socialSection2['default'], {
                title: 'Share with your network!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/204169818-Eventbrite' }),
            _react2['default'].createElement(PricingPlansCTA, { position: 'bottom' })
        )
    );
}

function IllustrationArea(p) {
    // This overlay is slightly off from the other integrations. This transform
    // compensate for that.
    var imageStyle = { transform: 'translateY(1px)' };
    return _react2['default'].createElement(
        'div',
        { className: 'top row drobox-blue' },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _eventbrite_logo2['default'], alt: 'Eventbrite Logo', className: 'dropbox-logo', width: '130' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Seamlessly Collect Event Waivers and Forms'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
                    'The HelloSign Waivers & Forms extension for Eventbrite allows you to send any event-related documents to your attendees for legally-binding signature. We\u2019ve made it easy to send, track, collect, and get real-time status updates on your photo releases, sponsor and exhibitor agreements, permission slips, waivers, and more for your Eventbrite event.'
                )
            ),
            _react2['default'].createElement(SignupButton, p)
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns' },
            _react2['default'].createElement('img', { src: _eventbrite_integration2['default'], alt: 'cloud left', style: { marginTop: 23 } })
        ),
        _react2['default'].createElement('img', { src: _overlay_left2['default'],
            style: imageStyle,
            alt: 'cloud left',
            className: 'cloud-left'
        }),
        _react2['default'].createElement('img', { src: _overlay_right2['default'],
            style: imageStyle,
            alt: 'cloud right',
            className: 'cloud-right'
        })
    );
}

function SignupButton() {
    var buttonClass = 'm-button bg-cerulean hc-white c-white progress-button state-loading m-login-or-signup--sign-up-button';
    var linkURL = 'https://www.eventbrite.com/spectrum/hellosign/';

    return _react2['default'].createElement(
        'div',
        { className: 'signup-button' },
        _react2['default'].createElement(
            'a',
            { href: linkURL, className: buttonClass },
            'ENABLE HELLOSIGN WAIVERS & FORMS'
        )
    );
}

function Benefits(p) {
    var titleStyle = {
        display: 'inline-block',
        maxWidth: 250
    };
    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__benefits' },
        _react2['default'].createElement(
            'h2',
            null,
            'Benefits'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'section',
                { className: 'access-dropbox-from-hs large-4 columns' },
                _react2['default'].createElement(
                    'div',
                    { className: 'benefits-image-container' },
                    _react2['default'].createElement('img', { src: _send_icon2['default'], alt: 'folder icon' })
                ),
                _react2['default'].createElement(
                    'h3',
                    null,
                    _react2['default'].createElement(
                        'span',
                        { style: titleStyle },
                        'Send important forms automatically'
                    )
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Send your event documents to attendees that have already registered and to any new attendees automatically as they join. We can pre-fill fields they\u2019ve already entered.'
                )
            ),
            _react2['default'].createElement(
                'section',
                { className: 'sign-any-from-dropbox large-4 columns' },
                _react2['default'].createElement(
                    'div',
                    { className: 'benefits-image-container' },
                    _react2['default'].createElement('img', { src: _customize_logo2['default'], alt: 'signature icon' })
                ),
                _react2['default'].createElement(
                    'h3',
                    null,
                    _react2['default'].createElement(
                        'span',
                        { style: titleStyle },
                        'Customize your documents'
                    )
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Upload unique documents for different ticket types, automatically pull attendee data into your documents, and brand your documents with your logo, company name, and more!'
                )
            ),
            _react2['default'].createElement(
                'section',
                { className: 'save-signed-copies large-4 columns end' },
                _react2['default'].createElement(
                    'div',
                    { className: 'benefits-image-container' },
                    _react2['default'].createElement('img', { src: _dashboard_icon2['default'], alt: 'cloud icon' })
                ),
                _react2['default'].createElement(
                    'h3',
                    null,
                    _react2['default'].createElement(
                        'span',
                        { style: titleStyle },
                        'Get real-time status reports'
                    )
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Check the status of any document out for signature for any attendee from your Eventbrite dashboard and download a report to simplify day-of-event check-ins.'
                )
            )
        )
    );
}

function HowItWorks(p) {
    var linkURL = 'http://blog.hellosign.com/hellosign-and-eventbrite-integration/';
    var link = _react2['default'].createElement(
        'a',
        { href: linkURL },
        'Read our blog post'
    );
    var videoProps = {
        src: 'https://www.youtube.com/embed/mQkUMjH_DxE',
        frameBorder: 0,
        style: {
            width: '100%',
            maxWidth: 800,
            height: 430
        }
    };
    var paragraphStyle = {
        marginLeft: 20
    };

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-3 large-push-9 columns' },
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'To get started, find the HelloSign Waivers & Forms extension in Eventbrite Spectrum.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'Once you add the extension to your event, you can upload documents, assign them to ticket types, automatically send your documents to registered attendees, and see which documents are still out for signature.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'All of the docs you send through the extension will show up in the documents view on HelloSign.com.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'Want to learn more about the integration? ',
                    link,
                    '.'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-9 large-pull-3 columns' },
                _react2['default'].createElement('iframe', videoProps)
            )
        )
    );
}

function PricingPlansCTA(p) {
    var position = p.position;
    var className = 'seo-cloud-integrations__main__free_accounts__' + position;
    var linkURL = 'eventbrite/pricing';
    var link = _react2['default'].createElement(
        'a',
        { href: linkURL, style: { fontWeight: 500 } },
        'See Our Plans'
    );
    var border = '2px solid #D7D7D7';
    var style = {};
    if (position === 'top') {
        style['borderBottom'] = border;
        style['backgroundColor'] = '#f7f8f9';
    } else {
        style['borderTop'] = border;
    }

    return _react2['default'].createElement(
        'div',
        { className: className, style: style },
        _react2['default'].createElement(
            'p',
            { style: { fontWeight: 600, lineSpacing: 0 } },
            'The HelloSign Waivers and Forms extension for Eventbrite plans start at $29 a month. ',
            link,
            '.'
        )
    );
}

module.exports = EventbriteLandingPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/eventbrite-landing-page.jsx
 ** module id = 1263
 ** module chunks = 0
 **/